/**
 * Test Admin API — job profiles, custom tests, questions, catalog viewer.
 */

import { apiFetch } from './core'

export const testAdmin = {
    listProfiles: (search = '', category = '', industry = '') => {
        const qs = new URLSearchParams({ search })
        if (category) qs.set('category', category)
        if (industry) qs.set('industry', industry)
        return apiFetch(`/test-admin/job-profiles?${qs}`)
    },
    listProfileCategories: () => apiFetch('/test-admin/job-profiles/categories'),
    createProfile: (data) => apiFetch('/test-admin/job-profiles', { method: 'POST', body: JSON.stringify(data) }),
    getProfile: (id) => apiFetch(`/test-admin/job-profiles/${id}`),
    updateProfile: (id, data) => apiFetch(`/test-admin/job-profiles/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    deleteProfile: (id) => apiFetch(`/test-admin/job-profiles/${id}`, { method: 'DELETE' }),
    generateProfileFromRequisition: (reqId) =>
        apiFetch(`/test-admin/job-profiles/generate/from-requisition/${reqId}`, { method: 'POST' }),
    generateProfileFromVacancy: (vacId) =>
        apiFetch(`/test-admin/job-profiles/generate/from-vacancy/${vacId}`, { method: 'POST' }),
    applyProfileToRequisition: (profileId, reqId) =>
        apiFetch(`/test-admin/job-profiles/${profileId}/apply-to-requisition/${reqId}`, { method: 'POST' }),
    applyProfileToVacancy: (profileId, vacId) =>
        apiFetch(`/test-admin/job-profiles/${profileId}/apply-to-vacancy/${vacId}`, { method: 'POST' }),
    reconcilePreview: (profileId, onlyUnbound = true) =>
        apiFetch(`/test-admin/job-profiles/${profileId}/reconcile-preview?only_unbound=${onlyUnbound}`),
    reconcileApply: (profileId, body = {}) =>
        apiFetch(`/test-admin/job-profiles/${profileId}/reconcile-apply`, {
            method: 'POST', body: JSON.stringify(body),
        }),
    profileTaxonomy: (profileId) =>
        apiFetch(`/test-admin/job-profiles/${profileId}/taxonomy`),
    suggestProfiles: ({ vacancyId, title, description, limit = 5 } = {}) => {
        const qs = new URLSearchParams()
        if (vacancyId) qs.set('vacancy_id', vacancyId)
        if (title) qs.set('title', title)
        if (description) qs.set('description', description)
        qs.set('limit', String(limit))
        return apiFetch(`/test-admin/job-profiles/suggest?${qs}`)
    },
    listCompetencies: (category = '') => {
        const qs = category ? `?category=${encodeURIComponent(category)}` : ''
        return apiFetch(`/test-admin/competencies${qs}`)
    },

    listTests: (search = '', type = '') => {
        let url = `/test-admin/custom-tests?search=${encodeURIComponent(search)}`
        if (type) url += `&test_type=${type}`
        return apiFetch(url)
    },
    createTest: (data) => apiFetch('/test-admin/custom-tests', { method: 'POST', body: JSON.stringify(data) }),
    getTest: (id) => apiFetch(`/test-admin/custom-tests/${id}`),
    updateTest: (id, data) => apiFetch(`/test-admin/custom-tests/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    deleteTest: (id) => apiFetch(`/test-admin/custom-tests/${id}`, { method: 'DELETE' }),

    listQuestions: (testId) => apiFetch(`/test-admin/custom-tests/${testId}/questions`),
    addQuestion: (testId, data) => apiFetch(`/test-admin/custom-tests/${testId}/questions`, { method: 'POST', body: JSON.stringify(data) }),
    updateQuestion: (testId, qId, data) => apiFetch(`/test-admin/custom-tests/${testId}/questions/${qId}`, { method: 'PUT', body: JSON.stringify(data) }),
    deleteQuestion: (testId, qId) => apiFetch(`/test-admin/custom-tests/${testId}/questions/${qId}`, { method: 'DELETE' }),
    bulkAddQuestions: (testId, questions) => apiFetch(`/test-admin/custom-tests/${testId}/questions/bulk`, { method: 'POST', body: JSON.stringify({ questions }) }),
    reorderQuestions: (testId, ids) => apiFetch(`/test-admin/custom-tests/${testId}/questions/reorder`, { method: 'POST', body: JSON.stringify({ question_ids: ids }) }),

    catalogQuestions: (code) => apiFetch(`/test-admin/catalog-questions/${code}`),
}
